import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import withRouter, { WithRouterProps } from '../routes/withRouter';

import { Container, Row, Alert } from 'reactstrap';
import api from '../utils/Api';
import { trackEvent } from '../utils/Analytics';

import * as QueryString from 'query-string';

import bannerLogo from '../images/Jook_Web_White.png';

import './ForgotPasswordCompleteView.scss';

interface ForgotPasswordCompleteViewProps extends WithRouterProps {}

interface ForgotPasswordCompleteViewState {
  error: string;
  success: string;
  loading: boolean;
  password: string;
  confirmPassword: string;
  email: string;
  key: string;
}

class ForgotPasswordCompleteView extends Component<ForgotPasswordCompleteViewProps, ForgotPasswordCompleteViewState> {
  constructor(props: ForgotPasswordCompleteViewProps) {
    super(props);

    this.state = {
      error: '',
      success: '',
      loading: false,
      password: '',
      confirmPassword: '',
      email: '',
      key: '',
    };
  }

  isValid(): boolean {
    const { password, confirmPassword } = this.state;
    let valid = false;

    if (password.length > 0 && confirmPassword.length > 0) {
      valid = true;
    }

    if (password.length === 0) {
      this.showError('You must enter a password');
      valid = false;
    } else if (password.length < 8) {
      this.showError('Your password must be at least 8 characters!');
      valid = false;
    } else if (confirmPassword.length === 0) {
      this.showError('You must retype your password');
      valid = false;
    } else if (password !== confirmPassword) {
      this.showError('Your passwords do not match.\nPlease check and try again.');
      valid = false;
    }

    return valid;
  }

  private onSubmit = async (e: React.FormEvent<HTMLFormElement>): Promise<void> => {
    e.preventDefault();

    if (!this.isValid()) {
      return;
    }

    const params = QueryString.parse(this.props.location.search);
    const email = params.email as string;
    const key = params.key as string;

    const { password } = this.state;

    this.setState({ loading: true });
    api
      .auth('forgot-password-complete', 'POST', {
        email: email,
        key: key,
        password: password,
      })
      .then((response) => {
        this.setState({ loading: false });
        trackEvent('password_reset_completed');
        this.showSuccess('Password changed successfully');
        console.log('Password changed successfully');
        setTimeout(this.navigateHome, 3000);
      })
      .catch((error) => {
        this.setState({ loading: false });
        this.showError(error.message);
        console.log('There has been a problem with your signup operation: ' + error.message);
      });
  };

  navigateHome = () => {
    this.props.navigate('/');
  };

  showError = (errorText: string) => {
    this.setState({ error: errorText, success: '' });
  };

  showSuccess = (successText: string) => {
    this.setState({ success: successText, error: '' });
  };

  render() {
    return (
      <Container fluid>
        <Row className="public-header-row">
          <div className="col public-header">
            <div className="d-flex justify-content-between">
              <Link to="/">
                <img className="logo" src={bannerLogo} alt="Jookable logo image" />
              </Link>
              <div />
            </div>
          </div>
        </Row>

        <Row className="g-0">
          <div className="col">
            <div className="public-page-content">
              <div className="public-page-formwrapper">
                <h1 className="public-page-formaccess">Enter New Password</h1>
                <form onSubmit={this.onSubmit.bind(this)} noValidate className="public-page-form">
                  {this.state.error && <Alert color="danger">{this.state.error}</Alert>}
                  {this.state.success && <Alert color="success">{this.state.success}</Alert>}
                  <input
                    type="password"
                    name="password"
                    placeholder="Enter New Password"
                    value={this.state.password}
                    onChange={(e) => this.setState({ password: e.target.value.trim() })}
                  />
                  <input
                    type="password"
                    name="confirmPassword"
                    placeholder="Retype New Password"
                    value={this.state.confirmPassword}
                    onChange={(e) => this.setState({ confirmPassword: e.target.value.trim() })}
                  />
                  <button className="button">Update Password</button>
                </form>
              </div>
            </div>
          </div>
        </Row>
      </Container>
    );
  }
}

export default withRouter(ForgotPasswordCompleteView);
